// extracted by mini-css-extract-plugin
export default {"wrapper":"Banner_wrapper__n1AOb","banner":"Banner_banner__FbEsJ"};